var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 98.2207C76.3066 98.2207 98.4746 76.0527 98.4746 49.2461C98.4746 22.3906 76.3066 0.271484 49.4512 0.271484C22.6445 0.271484 0.525391 22.3906 0.525391 49.2461C0.525391 76.0527 22.6934 98.2207 49.5 98.2207ZM44.1289 72.8789C42.8594 72.8789 41.834 72.3418 40.8574 71.0723L27.5762 55.2031C27.0391 54.4219 26.6484 53.5918 26.6484 52.7129C26.6484 51.0039 28.0156 49.6367 29.6758 49.6367C30.75 49.6367 31.6289 50.0273 32.5078 51.1992L43.9824 65.3105L66.4434 29.7637C67.127 28.6406 68.1035 28.0059 69.1289 28.0059C70.7402 28.0059 72.3027 29.1777 72.3027 30.9355C72.3027 31.7168 71.8633 32.5957 71.375 33.3281L47.2539 71.0723C46.4727 72.293 45.3984 72.8789 44.1289 72.8789Z",
    fill: "#41CD8C"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.a18f467c0d99107220b73a330c91d416.svg";
export { ForwardRef as ReactComponent };